(() => {
  if (window.RareTCGHeaderLayout) return;

  let owner = null;
  let observer = null;
  let frame = 0;
  let lastPublishedOwner = undefined;
  let lastPublishedSignature = '';

  function getVisibleHeaderHeight() {
    const layers = [
      document.querySelector('.rtcg-htb'),
      document.querySelector('.section-header'),
      document.querySelector('.rtcg-menu-system'),
    ].filter(Boolean);

    return layers.reduce((bottom, layer) => {
      const rect = layer.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return bottom;
      return Math.max(bottom, Math.min(window.innerHeight, rect.bottom));
    }, 0);
  }

  function publish() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      owner = document.querySelector('.section-header');
      if (!owner) {
        if (lastPublishedOwner !== null) {
          lastPublishedOwner = null;
          lastPublishedSignature = '';
          document.documentElement.style.setProperty('--rtcg-header-stack-height', '0px');
        }
        return;
      }

      const stickyEnabled = !!owner.querySelector('sticky-header');
      const hidden = owner.classList.contains('shopify-section-header-hidden');
      const visibleHeight = Math.max(0, Math.round(getVisibleHeaderHeight()));
      const signature = `${visibleHeight}:${stickyEnabled}:${hidden}`;

      // MOB-603: avoid redundant style writes and document events when
      // ResizeObserver or unrelated responsive changes report the same state.
      if (owner === lastPublishedOwner && signature === lastPublishedSignature) {
        window.RareTCGPerfAudit?.record?.('headerNoop');
        return;
      }
      window.RareTCGPerfAudit?.record?.('headerPublished');
      lastPublishedOwner = owner;
      lastPublishedSignature = signature;

      document.documentElement.style.setProperty('--rtcg-header-stack-height', `${visibleHeight}px`);
      document.dispatchEvent(new CustomEvent('rtcg:header-layout', {
        detail: { height: visibleHeight, sticky: stickyEnabled, hidden }
      }));
    });
  }

  function observe() {
    const nextOwner = document.querySelector('.section-header');
    if (nextOwner !== owner) {
      observer?.disconnect();
      owner = nextOwner;
      if (owner && 'ResizeObserver' in window) {
        observer = new ResizeObserver(publish);
        [document.querySelector('.rtcg-htb'), owner, document.querySelector('.rtcg-menu-system')]
          .filter(Boolean)
          .forEach((layer) => observer.observe(layer));
      }
    }
    publish();
  }

  document.addEventListener('rtcg:header-state', publish);
  window.addEventListener('resize', publish, { passive: true });
  document.addEventListener('shopify:section:load', observe);
  document.addEventListener('shopify:section:unload', observe);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe, { once: true });
  } else {
    observe();
  }

  window.RareTCGHeaderLayout = { publish };
})();
